import { render, staticRenderFns } from "./HomeTour.vue?vue&type=template&id=05ff99cf&"
import script from "./HomeTour.vue?vue&type=script&lang=js&"
export * from "./HomeTour.vue?vue&type=script&lang=js&"
import style0 from "./HomeTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports